// extracted by mini-css-extract-plugin
module.exports = {"BulletPoint":"gFq6PO-DJhgMdmvWbNdGA","paragraph":"_2hqMJv-qFw_3xN4GqaDHNF"};